
import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { StepperComponent } from '../../blocks';
import { UserSessionService, PatientParms } from '../../shared';
//services
import { RegpatHistoryOnOldSystem, RegpatHistoryOnOldSystemService } from './old-system-history.service';
import { ModalService } from '../../blocks';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { PrintComponent } from '../../blocks/print-component/print-component';
@Component({
    selector: 'old-system-history',
    templateUrl: './old-system-history.component.html'
})

export class RegpatHistoryOnOldSystemComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    myStepNumber: number = 2121;
    @Input() stepperComponent: StepperComponent;

    @ViewChild('printComponent') printComponent: PrintComponent;
    patientParms: PatientParms = <PatientParms>{};
    patInfo: any = <any>{};
    regpatHistoryOnOldSystemArr: any[] = [];
    selectedImage: any = <any>{};
    images: any[] = [];
    constructor(
        private _regpatHistoryOnOldSystemService: RegpatHistoryOnOldSystemService,
        private _route: ActivatedRoute,
        private _location: Location,
        public translate: TranslateService,
        private _userSessionService: UserSessionService,
        private _modalService: ModalService
    ) { }

    ngOnInit() {
        this._userSessionService.subscribeToKey$('PatientListComponent').pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys && keys.value) {
                    let _patientForEdit = keys.value;
                    if (_patientForEdit) {
                        this.patientParms.patCode = _patientForEdit['code'];
                    }
                    this.myStepper$();
                    this.getInputsAsStep$();
                    this.getPatOldHistoryDetail();
                }
            });


        this.getPatOldHistoryDetail();



        ///gouhar
        this._userSessionService
            .subscribeToKey$('PatientListComponent').pipe(
                takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys && keys.name == 'PatientListComponent') {
                    if (keys.value && keys.value) {
                        this.patientParms.patCode = keys.value['code'];//this._userSessionService.getSessionKey('relativeParent')
                        this.getPatOldHistoryDetail();
                    }
                }
            });
    }

    getPatOldHistoryDetail() {
        this.selectedImage = null;
        this.images=[];
		this.patInfo = [] ;
		this.regpatHistoryOnOldSystemArr = [] ;
        let id = this.patientParms.patCode;
        if (id > 0) {
            this._regpatHistoryOnOldSystemService.getPatOldSystemHistoryDetail(id).subscribe(
                res => {
                    if (res.data && res.data.length > 0) {
                        this.patInfo = res.data[0];
                    }
                    if (res.data1 && res.data1.length > 0) {
                        this.regpatHistoryOnOldSystemArr = res.data1;
                    }
                    if (res.data2 && res.data2.length > 0) {
                        this.images = res.data2;
                    }
                    setTimeout(() => { if (this.printComponent) { this.printComponent.PrintView() } }, 100);
                }
            );
        }
    }


    viewImage(image: { id: number; thumbnail: string }): void {
        if (image.id > 0) {
            this._regpatHistoryOnOldSystemService.getPatOldImage(image.id).subscribe(
                res => {
                    if (res.data && res.data.length > 0) {
                        this.selectedImage = res.data[0];
                    }
                }
            )
        }
    }
    close(): void {
        this.selectedImage = null;
        this.getPatOldHistoryDetail();
    }

    goBack(): void {
        this._location.back();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    //-----observable on step on wizard
    myStepper$() {
        if (this.stepperComponent) {
            this.stepperComponent.getCurrentStep().pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe((step: any) => {
                    if (step && step.serial == this.myStepNumber) {
                        this.getPatOldHistoryDetail();
                    }

                })
        }
    }
    //-----observable if it popuped
    getInputsAsPopub$() {
        this._userSessionService.getModalKey$().pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.name == 'OldSystemHistoryComponent' && keys.inputs) {
                    this.patientParms.patCode = keys.inputs['code'];
                    this.getPatOldHistoryDetail();
                }
            });
    }
    //-----observable if it popuped
    getInputsAsStep$() {
        this._userSessionService.getSessionKey$('patientForEdit')
            .subscribe((keys: any) => {
                if (keys && keys.name == 'patientForEdit' && keys.value["code"]) {
                    this.patientParms.patCode = keys.value["code"];
                }
            });
    }


    deleteOldSystemHistory(regpatHistoryOnOldSystem: any) {
        this._modalService.activeDelMes(regpatHistoryOnOldSystem.fullnameAr, regpatHistoryOnOldSystem.relativeNameAr).then(responseOK => {
            if (responseOK) {
                this._regpatHistoryOnOldSystemService.deletePatOldSystemHistory(regpatHistoryOnOldSystem.serial)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(c => {
                    }, error => console.log(error),

                        () => this.getPatOldHistoryDetail());

            }


        });

    }
}
